module.exports = __webpack_public_path__ + "img/kommune-822.d93b458c.svg";